import $ from 'jquery'

const object = orecaObject;

const searchForm = $('.js-search')
const searchInput = $('.js-search-input')
const catSelect = $('.js-select-tax')
const blogSection = $('.js-posts-container')
const paginateSection = $('.js-paginate')

catSelect.on('change', function () {
    post_search()
} );

searchInput.on('keyup', function () {
    post_search()
});

function post_search () {
    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
            nonce: object.nonce,
            action: 'oreca_post_search',
            keyword: searchInput.val(),
            term: catSelect.val(),
            post: $('.js-filter-post').attr('data-post-type'),
            taxo: $('.js-filter-tax').attr('data-tax'),
        },
        success: function (res) {
            if (res.length !== 0) {
                blogSection.html('')
                paginateSection.html(res.data.paginate)
                res.data.data.forEach((item, index) => {
                    blogSection.append(item)
                })
            }
        },
    });
}

